import { render, staticRenderFns, recyclableRender, components } from "./u-read-more.vue?vue&type=template&id=35272c51&scoped=true&"
var renderjs
import script from "./u-read-more.vue?vue&type=script&lang=js&"
export * from "./u-read-more.vue?vue&type=script&lang=js&"
import style0 from "./u-read-more.vue?vue&type=style&index=0&id=35272c51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35272c51",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-read-more/u-read-more.vue"
export default component.exports